export type HeroButtonVariant =
    | 'solid-mudpie'
    | 'solid-white'
    | 'solid-yellow'
    | 'solid-butter'
    | 'solid-midnight'
    | 'solid-orange'
    | 'solid-red'
    | 'solid-creator'
    | 'border-creator'
    | 'border-white';

export interface HeroImage {
    desktop: string;
    mobile: string;
    alt: string;
    colorway?: string;
    colorwayId?: string;
    isNew?: boolean;
    tagline1: string;
    tagline2?: string;
    tagline3?: string;
    tagline3ClassName?: string;
    startDate?: string; // ISO date string: '2024-11-21' or full datetime: '2024-11-21T00:00:00'
    endDate?: string;   // ISO date string: '2024-11-27' or full datetime: '2024-11-27T23:59:59'
    description?: string;
    buttonVariant?: HeroButtonVariant;
    buttonText?: string;
    secondaryButtonText?: string;
    secondaryButtonVariant?: HeroButtonVariant;
    secondaryButtonHref?: string;
    secondaryButtonExternal?: boolean;
    secondaryButtonCode?: string;
    accentColor?: string;
    textColor?: string;
    externalLink?: string;
    desktopWidth?: number;
    desktopHeight?: number;
    mobileWidth?: number;
    mobileHeight?: number;
}

export const HERO_IMAGES: HeroImage[] = [
    // {
    //     desktop: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/mudpie_hero_desktop.webp',
    //     mobile: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/mudpie_hero_mobile.webp',
    //     alt: 'Mudpie Hero Image',
    //     colorway: 'Mudpie',
    //     colorwayId: '683703f89b03e80f20e8bfb8',
    //     isNew: true,
    //     tagline1: 'From Earth\'s Waste,',
    //     tagline2: ' Nature\'s Best',
    //     description: 'Crafted from organic waste from clay and wheat - our Mudpie colourway transforms agricultural byproducts into beautiful, sustainable headphones',
    //     buttonVariant: 'solid-mudpie',
    //     accentColor: 'text-[#A46F4A]',
    //     textColor: 'text-yellow-100'
    // },
    // {
    //     desktop: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/seashell_hero_desktop.webp',
    //     mobile: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/seashell_hero_mobile.webp',
    //     alt: 'Seashell Hero Image',
    //     colorway: 'Seashell',
    //     colorwayId: '683703f89b03e80f20e8bfb8',
    //     isNew: true,
    //     tagline1: 'Ocean\'s Bounty,',
    //     tagline2: ' Sound\'s Beauty',
    //     description: 'Made from mussel and scallop shells - our Seashell colourway gives marine waste a second life as stunning, eco-friendly headphones',
    //     buttonVariant: 'solid-white',
    //     accentColor: 'text-white',
    //     textColor: 'text-white'
    // }
    // Uncomment to add more hero images:

    // {
    //     desktop: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/christmas_hero_desktop.webp',
    //     mobile: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/christmas_hero_mobile.webp',
    //     alt: 'Kibu Headphones Christmas',
    //     colorway: 'Headphones',
    //     colorwayId: '674ea943197065b8a54a3235',
    //     isNew: false,
    //     tagline1: 'Christmas Day is',
    //     tagline2: 'Just the Beginning',
    //     startDate: '2025-12-04',
    //     endDate: '2025-12-31T23:59:59',
    //     description: 'They’re not just building headphones, they’re building STEM skills for life.',
    //     buttonVariant: 'solid-red',
    //     accentColor: 'text-white',
    //     textColor: 'text-white',
    //     desktopWidth: 2490,
    //     desktopHeight: 1400,
    //     mobileWidth: 1080,
    //     mobileHeight: 1920
    // },
    {
        desktop: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/dragons_den_hero_desktop.webp',
        mobile: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/dragons_den_hero_mobile.webp',
        alt: 'Kibu Dragons Den',
        colorway: 'Headphones',
        colorwayId: '683703f89b03e80f20e8bfb8',
        isNew: false,
        tagline1: 'As Seen on',
        tagline2: "Dragons' Den",
        description: "The headphones that wowed the Dragons. Build, repair and recycle your own pair.",
        buttonVariant: 'solid-yellow',
        accentColor: 'text-white',
        textColor: 'text-white',
        desktopWidth: 2490,
        desktopHeight: 1400,
        mobileWidth: 1920,
        mobileHeight: 1080
    },
    {
        desktop: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/09/23/91348abea6214bd4a06ac723538f2cc7-dream_pop_hero_desktop.webp',
        mobile: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/09/23/3533fab9e8234ccd93afcabe065207ee-dream_pop_hero_mobile.webp',
        alt: 'Kibu Headphones Dream Pop',
        colorway: 'Dream Pop',
        colorwayId: '6ab283a8a9c09ce409f2ee61',
        isNew: true,
        tagline1: 'Soft Shades,',
        tagline2: ' Big Imagination',
        description: 'A playful pastel colourway for young makers with big ideas.',
        buttonVariant: 'solid-yellow',
        accentColor: 'text-pink-900',
        textColor: 'text-pink-900',
        desktopWidth: 2490,
        desktopHeight: 1400,
        mobileWidth: 1920,
        mobileHeight: 1080
    },
        {
        desktop: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/10/15/8f02684355c04136afa345f7b91665d3-woodland_walk_hero_desktop.jpg',
        mobile: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/10/15/0fc4fa2d64ba4af199a8d197db167c25-woodland_walk_hero_mobile.jpg',
        alt: 'Kibu Headphones Woodland Walk',
        colorway: 'Woodland Walk',
        colorwayId: '6ac4fc4c3224c7952fc09d8a',
        isNew: true,
        tagline1: 'Into the Woods,',
        tagline2: ' Built to Explore',
        description: 'Fresh forest tones for curious young makers who love to explore.',
        buttonVariant: 'solid-yellow',
        accentColor: 'text-white',
        textColor: 'text-white',
        desktopWidth: 2490,
        desktopHeight: 1400,
        mobileWidth: 1080,
        mobileHeight: 1920
    },
    {
        desktop: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/10/15/f7931c5c5e154130944591f70c3dd320-turbo_dash_hero_desktop.jpg',
        mobile: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/media/2026/10/15/24254a85589e4c19a78750823374e497-turbo_dash_hero_mobile.jpg',
        alt: 'Kibu Headphones Turbo Dash',
        colorway: 'Turbo Dash',
        colorwayId: '6ac9733f576416c12a6f3163',
        isNew: true,
        tagline1: 'Full Speed Ahead,',
        tagline2: ' Made to Make',
        description: 'Bold, energetic colour for young makers ready to build, listen and go.',
        buttonVariant: 'solid-yellow',
        accentColor: 'text-white',
        textColor: 'text-white',
        desktopWidth: 2490,
        desktopHeight: 1400,
        mobileWidth: 1080,
        mobileHeight: 1920
    },
    {
        desktop: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/child_1_hero_desktop.webp',
        mobile: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/child_1_hero_mobile.webp',
        alt: 'Kibu Headphones worn by child',
        colorway: 'Headphones',
        colorwayId: '683703f89b03e80f20e8bfb8',
        isNew: false,
        tagline1: 'Build. Learn.',
        tagline2: ' Listen. Love.',
        description: 'Build your own headphones and learn valuable skills while protecting your ears and the planet.',
        buttonVariant: 'solid-yellow',
        accentColor: 'text-white',
        textColor: 'text-white',
        desktopWidth: 2490,
        desktopHeight: 1400,
        mobileWidth: 1920,
        mobileHeight: 1080
    },
    {
        desktop: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/midnight_berry_desktop.webp',
        mobile: 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/hero-images/midnight_berry_mobile.webp',
        alt: 'Kibu Headphones Midnight Berry',
        colorway: 'Midnight Berry',
        colorwayId: '683703f89b03e80f20e8bfb8',
        isNew: false,
        tagline1: 'Dark Tones,',
        tagline2: ' Bright Futures',
        description: 'A mysterious deep blue colourway for young audiophiles with sophisticated taste.',
        buttonVariant: 'solid-yellow',
        accentColor: 'text-blue-100',
        textColor: 'text-blue-100',
        desktopWidth: 2490,
        desktopHeight: 1400,
        mobileWidth: 1920,
        mobileHeight: 1080
    }
];
